import { Card, CardContent, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import {
  Drzava,
  IdentifikacijskiBroj,
  NazivOperateraPlatforme,
} from "../../../index";
import { TIP_IZVJESCA } from "../../../../enums";

const Index = () => {
  const { getValues, watch } = useFormContext();
  const tipIzvjesca = watch("tipIzvjesca");
  const postojiOslobodjenje = watch("postojiOslobodjenje");
  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardContent>
        <h5>Operater koji je izvjestio (Reporting Operator)</h5>
        <NazivOperateraPlatforme
          nazivOdjeljka={"naziv"}
          label={"*Naziv operatera platforme"}
          disabled={postojiOslobodjenje}
        />
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <Drzava
              nazivPolja={"drzavaIzvjestavanja.oznaka"}
              nazivPoljaEu={"drzavaIzvjestavanja.euSifra"}
              label={"Država izvještavanja* (Reporting country)"}
              disabled={
                tipIzvjesca == TIP_IZVJESCA.IZ_RH || postojiOslobodjenje
              }
              drzaveEu={true}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <IdentifikacijskiBroj
              nazivPolja={"identifikacijskiBroj"}
              disabled={postojiOslobodjenje}
            />
          </Grid>
          <Grid item xs={6}>
            <Drzava
              nazivPolja={"drzavaIzdavatelj.oznaka"}
              nazivPoljaEu={"drzavaIzdavatelj.euSifra"}
              label={"*Država izdavatelj (Issuer country)"}
              disabled={postojiOslobodjenje}
              drzaveEu={true}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
